import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="gallery"
export default class extends Controller {
  static targets = ["lightbox", "lightboxImage", "caption", "counter"]
  static values = { images: Array }

  connect() {
    this.currentIndex = 0
    this.boundKeydown = this.handleKeydown.bind(this)
  }

  open(event) {
    this.currentIndex = parseInt(event.currentTarget.dataset.index, 10)
    this.update()
    this.lightboxTarget.classList.remove("hidden")
    this.lightboxTarget.classList.add("flex")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.boundKeydown)
  }

  close() {
    this.lightboxTarget.classList.add("hidden")
    this.lightboxTarget.classList.remove("flex")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.boundKeydown)
  }

  closeOnBackdrop(event) {
    if (event.target === this.lightboxTarget) this.close()
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.imagesValue.length
    this.update()
  }

  previous() {
    this.currentIndex = (this.currentIndex - 1 + this.imagesValue.length) % this.imagesValue.length
    this.update()
  }

  handleKeydown(event) {
    if (event.key === "ArrowLeft") this.previous()
    if (event.key === "ArrowRight") this.next()
    if (event.key === "Escape") this.close()
  }

  update() {
    const image = this.imagesValue[this.currentIndex]
    this.lightboxImageTarget.src = image.src
    this.lightboxImageTarget.alt = image.alt
    this.captionTarget.textContent = image.alt
    this.counterTarget.textContent = `${this.currentIndex + 1} / ${this.imagesValue.length}`
  }
}
